import { createRouter, createWebHistory } from 'vue-router';
const PositionOffer = ['Position Offer', 'Position Offered', 'JobSeeker Details'];
const OtherPlatForm = ['Post Other Platform Request', 'Add Job Post', 'Job Post Details'];
const AdminManagement = ['Admin Management', 'Add Admin', 'Edit Admin'];
const JobSeekerManagement = ['Job Seeker', 'View Job Seeker'];
const RecruiterManagement = ['Recruiter', 'ViewRecruiter'];
const PurchaseManagement = ['Purchase Management', 'View Purchase', 'Add Purchase'];
const FreeManagement = ['Free', 'View Free'];
const NoticeManagement= ['Notice', 'Addnotice', 'ViewNotice', 'editNotice'];
const InquiryManagement = ['Inquiry', 'View Inquiry', 'Reply Inquiry']
function guest(to, from, next) {
    if (localStorage.token) {
        next({ name: 'User' });
    } else next();
}

function guard(to, from, next) {
    if (localStorage.token) {
        if (localStorage.token) {
            console.log(to, 'to');
            console.log(from, 'from');
            if (!PositionOffer.includes(from.name)) {
                // console.log("from.name", from.name);
                // alert("from.name", from);
                localStorage.removeItem('PositionOffer');
            }
            if (!OtherPlatForm.includes(from.name)) {
                localStorage.removeItem('OtherPlatForm');
            }
            if (!AdminManagement.includes(from.name)) {
                localStorage.removeItem('AdminManagement');
            }
            if (!JobSeekerManagement.includes(from.name)) {
                localStorage.removeItem('JobSeekerManagement');
            }
            if (!RecruiterManagement.includes(from.name)) {
                localStorage.removeItem('RecruiterManagement');
            }
            if (!PurchaseManagement.includes(from.name)) {
                localStorage.removeItem('PurchaseManagement');
            }
            if (!FreeManagement.includes(from.name)) {
                localStorage.removeItem('FreeManagement');
            }
            if (!NoticeManagement.includes(from.name)) {
                localStorage.removeItem('NoticeManagement');
            }
            if (!InquiryManagement.includes(from.name)) {
                localStorage.removeItem('InquiryManagement');
            }
        }
        next();
    } else {
        next({ name: 'login' });
    }
}

const routes = [
    {
        path: '/SubAdmin',
        name: 'SubAdmin',
        exact: true,
        component: () => import('./components/SubAdmin.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'SubAdmin', label: 'SubAdmin' }],
        },
    },
    {
        path: '/',
        name: 'Admin Dashboard',
        exact: true,
        component: () => import(`./pages/AdminManagement/AdminManagementList.vue`),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Dashboard' }],
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        redirect: '/error',
    },
    // account information start
    {
        path: '/account-info',
        name: 'AccountInfo',
        component: () => import('./pages/AccountManagement/AccontInfo.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'accountinfo' }],
        },
    },
    {
        path: '/change-pass',
        name: 'ChangePass',
        component: () => import('./pages/AccountManagement/ChangePass.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'ChangePass' }],
        },
    },
    {
        path: '/modify-info/:id',
        name: 'EditInfo',
        component: () => import('./pages/AccountManagement/EditInfo.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'EditInfo' }],
        },
    },
    //account information end
    //samsung 1.1 Inquery start
    {
        path: '/1.1_inquiry',
        name: 'Inquiry',
        component: () => import('./pages/inquiry/Inquiry.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'inquiry List' }],
        },
    },
    {
        path: '/inquiry_details/:id',
        name: 'View Inquiry',
        component: () => import('./pages/inquiry/InquiryDetails.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'inquiry Details' }],
        },
    },
    {
        path: '/ReplyInquiry/:id',
        name: 'Reply Inquiry',
        component: () => import('./pages/inquiry/ReplyInquiry.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Reply Inquiry' }],
        },
    },
    //samsung 1.1 Inquery End
    //samsung Notification Start
    {
        path: '/notification',
        name: 'NotificationList',
        component: () => import('./pages/notification/NotificationList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'notification List' }],
        },
    },
    {
        path: '/addnotification',
        name: 'AddNotificationList',
        component: () => import('./pages/notification/AddNotification.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'add notification' }],
        },
    },
    {
        path: '/viewnotification/:id',
        name: 'ViewNotificationList',
        component: () => import('./pages/notification/ViewNotification.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'view notification' }],
        },
    },
    //samsung Notification End

    //samsung Statistics Start
    {
        path: '/statistics/shop_category',
        name: 'shopCategory List',
        component: () => import('./pages/StatisticsManagement/shopCategory.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'shopcategory Id' }],
        },
    },
    {
        path: '/statistics/send_Report',
        name: 'Send Statistics Report',
        component: () => import('./pages/StatisticsManagement/sendStatisticsReport.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'send Report' }],
        },
    },
    {
        path: '/statistics/shop_category/:id',
        name: 'shopCategory_details',
        component: () => import('./pages/StatisticsManagement/shopCategoryId.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'shopcategory List' }],
        },
    },
    {
        path: '/statistics/shop_category/shop_name/products',
        name: 'shopCategory_products',
        component: () => import('./pages/StatisticsManagement/shopCategoryProducts.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'shopcategory_products List' }],
        },
    },
    //product_category
    {
        path: '/statistics/product_category',
        name: 'productCategory_List',
        component: () => import('./pages/StatisticsManagement/productCategory.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'productcategory List' }],
        },
    },
    {
        path: '/statistics/product_category/:id',
        name: 'productCategoryId_List',
        component: () => import('./pages/StatisticsManagement/productCategoryId.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'productcategory Id' }],
        },
    },
    {
        path: '/statistics/product_category_third',
        name: 'productCategoryThird List',
        component: () => import('./pages/StatisticsManagement/productCategoryThird.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'productcategory Third' }],
        },
    },
    {
        path: '/statistics/product_category_final',
        name: 'productCategoryFinal List',
        component: () => import('./pages/StatisticsManagement/productCategoryFinal.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'productcategory Final' }],
        },
    },
    //samsung Statistics End

    // samsung Product Category Start
    {
        path: '/ProductCategorylist',
        name: 'ProductCategorylist',
        component: () => import('./pages/ProductCategoryManagement/ProductCategorylist.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'product category List' }],
        },
    },
    {
        path: '/AddProductCategory',
        name: 'AddProductCategory',
        component: () => import('./pages/ProductCategoryManagement/AddProductCategory.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'add product category' }],
        },
    },
    {
        path: '/Editproductcategory/:id',
        name: 'Editproductcategory',
        component: () => import('./pages/ProductCategoryManagement/Editproductcategory.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'edit product category' }],
        },
    },
    {
        path: '/ViewProductcategory/:id',
        name: 'ViewProductcategory',
        component: () => import('./pages/ProductCategoryManagement/ViewProductcategory.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'view product category' }],
        },
    },
    // samsung Product Category End
    //samsung report_Management start
    {
        path: '/report',
        name: 'report List',
        component: () => import('./pages/report/ReportList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'report List' }],
        },
    },
    {
        path: '/report_details/:id',
        name: 'report Details',
        component: () => import('./pages/report/ReportDetails.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'report Details' }],
        },
    },
    //samsung report_Management end
    //samsung survey start
    {
        path: '/survey',
        name: 'surveyList',
        component: () => import('./pages/Survey/surveyList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'survey List' }],
        },
    },
    {
        path: '/create-survey',
        name: 'create survey',
        component: () => import('./pages/Survey/createSurvey.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'create survey' }],
        },
    },
    {
        path: '/edit-survey/:id',
        name: 'update survey',
        component: () => import('./pages/Survey/editSurvey.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'update survey' }],
        },
    },
    {
        path: '/view-survey/:id',
        name: 'viewSurvey',
        component: () => import('./pages/Survey/viewSurvey.vue'),
        beforeEnter: guard,
    },
    //samsung survey end
    //receipt Information start
    {
        path: '/receipt',
        name: 'receiptList',
        component: () => import('./pages/Receipt/receiptList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'receipt List' }],
        },
    },
    {
        path: '/receipt/upload-download-excel',
        name: 'Upload-download-excel',
        component: () => import('./pages/Receipt/downloadUploadExcel.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Upload-download-excel' }],
        },
    },
    {
        path: '/receipt/:id',
        name: 'receiptDetails',
        component: () => import('./pages/Receipt/receiptDetails.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'receipt details' }],
        },
    },
    //receipt Information end
    //samsung_coupon start
    {
        path: '/coupon',
        name: 'couponList',
        component: () => import('./pages/cououn/couponList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'coupon List' }],
        },
    },
    {
        path: '/coupon/create_new',
        name: 'createCoupon',
        component: () => import('./pages/cououn/AddCoupon.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'coupon Create' }],
        },
    },
    {
        path: '/coupon/:id',
        name: 'viewCoupon',
        component: () => import('./pages/cououn/couponDetails.vue'),
        beforeEnter: guard,
    },
    {
        path: '/UpdateCoupon/:id',
        name: 'updateCoupon',
        component: () => import('./pages/cououn/UpdateCoupon.vue'),
        beforeEnter: guard,
    },
    {
        path: '/assignCoupon/:id',
        name: 'assignCoupon',
        component: () => import('./pages/cououn/AssignCoupon.vue'),
        beforeEnter: guard,
    },
    //samsung_coupon end
    //dfc_banner start
    {
        path: '/BannerManagemet/BannerList',
        name: 'Banner Management',
        component: () => import('./pages/BannerManagemet/BannerList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'bannerlist' }],
        },
    },
    {
        path: '/add-banner',
        name: 'AddBanner',
        component: () => import('./pages/BannerManagemet/AddBanner.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'addbanner' }],
        },
    },
    {
        path: '/BannerManagemet/edit-banner/:id',
        name: 'EditBanner',
        component: () => import('./pages/BannerManagemet/EditBanner.vue'),
        beforeEnter: guard,
    },
    {
        path: '/view-banner/:id',
        name: 'ViewBanner',
        component: () => import('./pages/BannerManagemet/ViewBanner.vue'),
        beforeEnter: guard,
    },
    //dfc_banner end
    //Media_press start
    {
        path: '/media-press',
        name: 'MediaPressManagement',
        component: () => import('./pages/MediaPress/MediaPressList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'mediapress-list' }],
        },
    },
    {
        path: '/add-media-press',
        name: 'AddMediaPress',
        component: () => import('./pages/MediaPress/AddMediaPress.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'add-mediapress' }],
        },
    },
    {
        path: '/view-media-press/:id',
        name: 'ViewMediaPress',
        component: () => import('./pages/MediaPress/ViewMediaPress.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'view-mediapress' }],
        },
    },
    {
        path: '/edit-media-press/:id',
        name: 'EditMediaPress',
        component: () => import('./pages/MediaPress/EditMediaPress.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'edit-mediapress' }],
        },
    },
    //Media_press end
    //client-lookup start
    {
        path: '/client-lookup',
        name: 'ClientLookup',
        component: () => import('./pages/dfc_user/ClientLookup.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Client lookup' }],
        },
    },
    {
        path: '/uploaded-doclist',
        name: 'UploadedDoclist',
        component: () => import('./pages/dfc_user/UploadDoclist.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Upload Doclist' }],
        },
    },
    {
        path: '/upload-document',
        name: 'UploadDoc',
        component: () => import('./pages/dfc_user/UploadDoc.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Upload' }],
        },
    },
    {
        path: '/client-lookup/details/:id',
        name: 'Clientdetails',
        exact: true,
        component: () => import('./pages/dfc_user/ClientDetails.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'page', label: 'Client details' }],
        },
    },
    {
        path: '/dfc_user/personal-info',
        name: 'Personaldetails',
        exact: true,
        component: () => import('./pages/dfc_user/DfcPersonalinfo.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'page', label: 'personal details' }],
        },
    },
    //client-lookup end
    //Card-news start
    {
        path: '/card-news',
        name: 'CardNewsManagement',
        component: () => import('./pages/CardNews/CardNewsList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Card-News list' }],
        },
    },
    {
        path: '/add-card-news',
        name: 'AddCardNews',
        component: () => import('./pages/CardNews/AddCardNews.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Add-CardNews' }],
        },
    },
    {
        path: '/card-news/edit/:id',
        name: 'CardNewsedit',
        component: () => import('./pages/CardNews/EditCardNews.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit-cardnews' }],
        },
    },
    {
        path: '/card-news/view/:id',
        name: 'CardNewsView',
        component: () => import('./pages/CardNews/ViewCardNews.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'View-cardnews' }],
        },
    },
    //Card-news end

    {
        path: '/edit-nft/:id',
        name: 'EditNft',
        component: () => import('./pages/NftManagement/EditNft.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Edit-Nft' }],
        },
    },
    //NFT_end
    //dfc_popup start
    {
        path: '/popup-management',
        name: 'PopupManagement',
        component: () => import('./pages/PopupManagement/Popup.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'popuplist' }],
        },
    },
    {
        path: '/view-popup/:id',
        name: 'ViewPopupManagement',
        component: () => import('./pages/PopupManagement/ViewPopup.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'popup-view' }],
        },
    },
    {
        path: '/edit-popup/:id',
        name: 'EditPopupManagement',
        component: () => import('./pages/PopupManagement/EditPopup.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'popup-edit' }],
        },
    },

    //Frontend Popup Management start
    {
        path: '/FrontendPopup-management',
        name: 'FrontendPopup',
        exact: true,
        component: () => import('./pages/FrontendPopup/PopupList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'popup-list' }],
        },
    },
    {
        path: '/FrontendEdit-Popup/:id',
        name: 'FrontendEditPopup',
        exact: true,
        component: () => import('./pages/FrontendPopup/FrontendEditPopup.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Edit-popup' }],
        },
    },
    {
        path: '/FrontendPreview-Popup/:id',
        name: 'FrontendPreviewPopup',
        exact: true,
        component: () => import('./pages/FrontendPopup/PreviewPopup.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'Preview-popup' }],
        },
    },
    //Frontend Popup Mangement end

    //google-form start
    {
        path: '/google-form',
        name: 'GoogleForm',
        exact: true,
        component: () => import('./pages/Googleform/GoogleFormList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'User', label: 'google form' }],
        },
    },
    //google-form end
    {
        path: '/user',
        name: 'User',
        exact: true,
        component: () => import('./pages/user/User.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'User', label: 'User' }],
        },
    },
    {
        path: '/add-user',
        name: 'Adduser',
        exact: true,
        component: () => import('./pages/user/Adduser.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'User', label: 'Add User' }],
        },
    },
    {
        path: '/user/view-user/:id',
        name: 'ViewUser',
        exact: true,
        component: () => import('./pages/user/ViewUser.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'User', label: 'View User' }],
        },
    },
    {
        path: '/edit-notice/:id',
        name: 'editNotice',
        exact: true,
        component: () => import('./pages/notice/EditNotice.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Notice', label: 'Edit Notice' }],
        },
    },
    {
        path: '/user/edit-user/:id',
        name: 'UpdateUser',
        exact: true,
        component: () => import('./pages/user/UpdateUser.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'User', label: 'Update User' }],
        },
    },
    {
        path: '/notice/NoticeList',
        name: 'Notice',
        component: () => import('./pages/notice/NoticeList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Notice List' }],
        },
    },
    {
        path: '/add-notice',
        name: 'Addnotice',
        exact: true,
        component: () => import('./pages/notice/AddNotice.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Notice', label: 'Add Notice' }],
        },
    },
    {
        path: '/view-notice/:id',
        name: 'ViewNotice',
        exact: true,
        component: () => import('./pages/notice/ViewNotice.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Notice', label: 'View Notice' }],
        },
    },
    {
        path: '/inquiry-type',
        name: 'InquiryType',
        exact: true,
        component: () => import('./pages/inquiry/InquiryType.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'InquiryType' }],
        },
    },
    {
        path: '/add-inquiry-type',
        name: 'AddInquiryType',
        exact: true,
        component: () => import('./pages/inquiry/AddInquiryType.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'AddInquiryType' }],
        },
    },
    {
        path: '/edit-inquiry-type/:id',
        name: 'EditInquiryType',
        exact: true,
        component: () => import('./pages/inquiry/EditInquiryType.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'EditInquiryType' }],
        },
    },
    {
        path: '/inquiry/Inquiry',
        name: 'Inquiry',
        exact: true,
        component: () => import('./pages/inquiry/Inquiry.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Inuery', label: 'inquiry list' }],
        },
    },
    {
        path: '/edit-inquiry/:id',
        name: 'EditInquiry',
        exact: true,
        component: () => import('./pages/inquiry/EditInquiry.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'pages', label: 'EditInquiry' }],
        },
    },

    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue'),
        beforeEnter: guest,
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue'),
    },

    //Member Statistics
    {
        path: '/MemberStatistics/MemberStatisticslist',
        name: 'Member Statistics',
        component: () => import('./pages/MemberStatistics/MemberStatisticslist.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Member Statistics' }],
        },
    },
    //Member Management
    {
        path: '/MemberManagement/Recruiter/Recruiterlist',
        name: 'Recruiter',
        component: () => import('./pages/MemberManagement/Recruiter/Recruiterlist.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Member Management' }],
        },
    },
    {
        path: '/MemberManagement/Recruiter/ViewRecruiter/:id',
        name: 'ViewRecruiter',
        component: () => import('./pages/MemberManagement/Recruiter/ViewRecruiter.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'ViewRecruiter' }],
        },
    },
    {
        path: '/MemberManagement/JobSeeker/JobSeekerList',
        name: 'Job Seeker',
        component: () => import('./pages/MemberManagement/JobSeeker/JobSeekerList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'JobSeekerList' }],
        },
    },
    {
        path: '/MemberManagement/JobSeeker/ViewJobSeeker/:id',
        name: 'View Job Seeker',
        component: () => import('./pages/MemberManagement/JobSeeker/ViewJobSeeker.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'View Job Seeker' }],
        },
    },
    //Purchase Management
    {
        path: '/PurchaseManagement/PurchaseManagementlist',
        name: 'Purchase Management',
        component: () => import('./pages/PurchaseManagement/PurchaseManagementlist.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Purchase Management' }],
        },
    },
    {
        path: '/PurchaseManagement/ViewPurchaseManagement/:id',
        name: 'View Purchase',
        component: () => import('./pages/PurchaseManagement/ViewPurchaseManagement.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'ViewPurchaseManagement' }],
        },
    },
    {
        path: '/PurchaseManagement/AddNewPurchase',
        name: 'Add Purchase',
        component: () => import('./pages/PurchaseManagement/AddNewPurchase.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'AddNewPurchase' }],
        },
    },
    //Admin Management
    {
        path: '/AdminManagement/AdminManagementList',
        name: 'Admin Management',
        component: () => import('./pages/AdminManagement/AdminManagementList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Admin Management' }],
        },
    },
    {
        path: '/AdminManagement/AddAdmin',
        name: 'Add Admin',
        component: () => import('./pages/AdminManagement/AddAdmin.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Add Admin' }],
        },
    },
    {
        path: '/AdminManagement/EditAdmin/:id',
        name: 'Edit Admin',
        component: () => import('./pages/AdminManagement/EditAdmin.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Admin' }],
        },
    },
    //Information Management Service Terms
    {
        path: '/ServiceTerms/ServiceTermsList',
        name: 'Service Terms',
        component: () => import('./pages/ServiceTerms/ServiceTermsList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Service Terms' }],
        },
    },
    {
        path: '/ServiceTerms/EditServiceTerms/:update_key',
        name: 'Edit Service',
        component: () => import('./pages/ServiceTerms/EditServiceTerms.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Service' }],
        },
    },
    {
        path: '/ServiceTerms/ViewServiceTerms/:update_key',
        name: 'View Service',
        component: () => import('./pages/ServiceTerms/ViewServiceTerms.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'View Service' }],
        },
    },
    //Information Management General List
    {
        path: '/General/GeneralList',
        name: 'General',
        component: () => import('./pages/General/GeneralList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'General List' }],
        },
    },
    {
        path: '/General/EditGeneral/:update_key',
        name: 'Edit General',
        component: () => import('./pages/General/EditGeneral.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit General' }],
        },
    },
    //Paid Featured Management Package List
    {
        path: '/PaidFeatureManagement/PackageManagement/PackageList',
        name: 'Package',
        component: () => import('./pages/PaidFeatureManagement/PackageManagement/PackageList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Package List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/PackageManagement/EditPackage/:id',
        name: 'Edit Package',
        component: () => import('./pages/PaidFeatureManagement/PackageManagement/EditPackage.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Package' }],
        },
    },
    //Paid Featured Management Chodan Coin List
    {
        path: '/PaidFeatureManagement/ChodanCoin/ChodanCoinList',
        name: 'Chodan Coin',
        component: () => import('./pages/PaidFeatureManagement/ChodanCoin/ChodanCoinList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Package List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/ChodanCoin/EditChodanCoin/:id',
        name: 'Edit Chodan Coin',
        component: () => import('./pages/PaidFeatureManagement/ChodanCoin/EditChodanCoin.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Chodan Coin' }],
        },
    },
    //Paid Featured Management Free List
    {
        path: '/PaidFeatureManagement/Free/FreeList',
        name: 'Free',
        component: () => import('./pages/PaidFeatureManagement/Free/FreeList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Free List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/Free/ViewFree/:id',
        name: 'View Free',
        component: () => import('./pages/PaidFeatureManagement/Free/ViewFree.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'View Free' }],
        },
    },
    //Paid Featured Management Upgle List
    {
        path: '/PaidFeatureManagement/Upgle/UpgleList',
        name: 'Upgle',
        component: () => import('./pages/PaidFeatureManagement/Upgle/UpgleList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Upgle List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/Upgle/EditUpgle/:sub_type_id',
        name: 'Edit Upgle',
        component: () => import('./pages/PaidFeatureManagement/Upgle/EditUpgle.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Upgle' }],
        },
    },
    //Paid Featured Management Emergency List
    {
        path: '/PaidFeatureManagement/Emergency/EmergencyList',
        name: 'Emergency',
        component: () => import('./pages/PaidFeatureManagement/Emergency/EmergencyList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Emergency List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/Emergency/EditEmergency/:sub_type_id',
        name: 'Edit Emergency',
        component: () => import('./pages/PaidFeatureManagement/Emergency/EditEmergency.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Emergency' }],
        },
    },
    //Paid Featured Management Premium List
    {
        path: '/PaidFeatureManagement/Premium/PremiumList',
        name: 'Premium',
        component: () => import('./pages/PaidFeatureManagement/Premium/PremiumList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Premium List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/Premium/EditPremium/:sub_type_id',
        name: 'Edit Premium',
        component: () => import('./pages/PaidFeatureManagement/Premium/EditPremium.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Premium' }],
        },
    },
    //Paid Featured Management Special List
    {
        path: '/PaidFeatureManagement/Special/SpecialList',
        name: 'Special',
        component: () => import('./pages/PaidFeatureManagement/Special/SpecialList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Special List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/Special/EditSpecial/:sub_type_id',
        name: 'Edit Special',
        component: () => import('./pages/PaidFeatureManagement/Special/EditSpecial.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Special' }],
        },
    },
    //Paid Featured Management Line List
    {
        path: '/PaidFeatureManagement/Line/LineList',
        name: 'Line',
        component: () => import('./pages/PaidFeatureManagement/Line/LineList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Line List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/Line/EditLine/:sub_type_id',
        name: 'Edit Line',
        component: () => import('./pages/PaidFeatureManagement/Line/EditLine.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Line' }],
        },
    },
    //Paid Featured Management Talent Search List
    {
        path: '/PaidFeatureManagement/TalentSearch/TalentSearchList',
        name: 'Talent Search',
        component: () => import('./pages/PaidFeatureManagement/TalentSearch/TalentSearchList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Talent Search List' }],
        },
    },
    {
        path: '/PaidFeatureManagement/TalentSearch/EditTalentSearch/:sub_type_id',
        name: 'Edit Talent Search',
        component: () => import('./pages/PaidFeatureManagement/TalentSearch/EditTalentSearch.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Edit Talent Search' }],
        },
    },

    //Position Offers
    {
        path: '/PositionOffer/PositionOfferlist',
        name: 'Position Offer',
        component: () => import('./pages/PositionOffer/PositionOfferlist.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Position Offer list' }],
        },
    },
    {
        path: '/PositionOffer/PositionOffered/:id',
        name: 'Position Offered',
        component: () => import('./pages/PositionOffer/PositionOffered.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Position Offered' }],
        },
    },
    {
        path: '/PositionOffer/JobSeekerDetails/:id',
        name: 'JobSeeker Details',
        component: () => import('./pages/PositionOffer/JobSeekerDetails.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'JobSeeker Details' }],
        },
    },
    //Post From Other Platform Request
    {
        path: '/PostOtherPlatform/PostOtherPlatformRequestList',
        name: 'Post Other Platform Request',
        component: () => import('./pages/PostOtherPlatform/PostOtherPlatformRequestList.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Post Other Platform Request' }],
        },
    },
    {
        path: '/PostOtherPlatform/AddJobPost/:id/:reqId',
        name: 'Add Job Post',
        component: () => import('./pages/PostOtherPlatform/AddJobPost.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Add Job Post' }],
        },
    },
    {
        path: '/PostOtherPlatform/JobPostDetails/:id',
        name: 'Job Post Details',
        component: () => import('./pages/PostOtherPlatform/JobPostDetails.vue'),
        beforeEnter: guard,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Job Post Details' }],
        },
    },

    //Forgot Password

    {
        path: '/forgotpassword',
        name: 'forgotpassword',
        component: () => import('./pages/forgotpassword.vue'),
        beforeEnter: guest,
    },
    {
        path: '/OtpEnter',
        name: 'OtpEnter',
        component: () => import('./pages/OtpEnter.vue'),
        beforeEnter: guest,
    },
    {
        path: '/changepassword',
        name: 'changepassword',
        component: () => import('./pages/changepassword.vue'),
        beforeEnter: guest,
    },
];

const router = createRouter({
    // history: createWebHashHistory(),
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    },
});

export default router;
